import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Userpilot } from 'userpilot';
import { getUserInfoDataSelector } from './core';

Userpilot.initialize('NX-4bc33e77');
@Component({
    selector: 'rose-portal-app',
    standalone: true,
    imports: [RouterOutlet],
    template: '<router-outlet/>',
    styles: ''
})
export class RosePortalAppComponent implements OnInit, OnDestroy {
    #sessionInfo!: Subscription;
    readonly #store: Store = inject(Store);

    readonly #router: Router = inject(Router);

    constructor() {
        this.#router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                Userpilot.reload();
            }
        });
    }

    ngOnInit(): void {
        this.#sessionInfo = this.#store.select(getUserInfoDataSelector).subscribe((userInfo) => {
            if (userInfo.rosekey) {
                Userpilot.identify(userInfo.preferred_username, {
                    name: userInfo.given_name,
                    email: userInfo.email,
                    fullName: userInfo.name,
                    lastName: userInfo.family_name,
                    userName: userInfo.preferred_username,
                    mobilephone: userInfo.preferred_username
                });
            }
        });

    }

    ngOnDestroy(): void {
        this.#sessionInfo.unsubscribe();
    }
}